import React from 'react'
import styled from 'styled-components/macro'
import {
  PrimaryTextArea,
  PrimaryTextAreaProps,
} from '../PrimaryTextArea/PrimaryTextArea'

export const PrimaryTextAreaOutlined = (props: PrimaryTextAreaProps) => {
  return <StyledInput {...props} />
}

const StyledInput = styled(PrimaryTextArea)<{ borderColor?: string }>`
  border-color: ${({ borderColor }) => borderColor};
  font-weight: 400;
  font-size: ${({ theme }) => theme.fontSize['12']};
  color: #929292;
  background-color: #fafafa;
  border-radius: 12px;
  box-sizing: border-box;
  box-shadow: unset;
  overflow: hidden;
  > .ant-input {
    font-size: ${({ theme }) => theme.fontSize['12']};
    color: #929292;
    background-color: #fafafa;
  }
`
